const DEFAULT_API_BASE_URL = 'http://localhost:5000';

export const normalizeApiBaseUrl = value => {
  const raw = value || DEFAULT_API_BASE_URL;
  const normalized = raw
    .trim()
    .replace(/^['"]|['"]$/g, '')
    .replace(/\/+$/g, '');

  return normalized || DEFAULT_API_BASE_URL;
};

export const API_BASE_URL = normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL);

export default API_BASE_URL;
